import { connect } from 'react-redux';
import Legal from './Legal';

import { setSelectedFinancing } from '../common/settings/actions';

const mapStateToProps = state => ({
    projectState: state.projectaddress.projectState,
    loanProvider: state.loan.loanProvider,
});

const combinedActions = {
    setSelectedFinancing,
};

export default connect(mapStateToProps, combinedActions)(Legal);



// WEBPACK FOOTER //
// ./src/containers/Legal/index.js